import {createContext} from 'react';

export const AuthContext = createContext({
    name: '',
    token: '',
    isLoggedIn: false,
    checkAuthentication: () => {},
    logout: () => {}
});